var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Fragment, useCallback, useMemo, useRef, useState } from "react";
import { Typeahead, Highlighter, Menu, MenuItem, Hint } from "react-bootstrap-typeahead";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

import "./../Select/FormSelect.scss";
import "./Search.scss";
import { ShIcon } from "../../..";
import { ShCloseSolid, ShSearch } from "../../Icons/Shoutout";

var SelectSingleInput = function SelectSingleInput(_ref) {
  var inputRef = _ref.inputRef,
      referenceElementRef = _ref.referenceElementRef,
      size = _ref.size,
      shouldSelectHint = _ref.shouldSelectHint,
      selectedValue = _ref.selectedValue,
      onClickClear = _ref.onClickClear,
      onClickSearch = _ref.onClickSearch,
      readonly = _ref.readonly,
      onBlur = _ref.onBlur,
      inputProps = _objectWithoutProperties(_ref, ["inputRef", "referenceElementRef", "size", "shouldSelectHint", "selectedValue", "onClickClear", "onClickSearch", "readonly", "onBlur"]);

  return React.createElement(
    Hint,
    { shouldSelect: shouldSelectHint },
    React.createElement(
      Fragment,
      null,
      React.createElement(Form.Control, _extends({
        autoComplete: "false"
      }, inputProps, {
        ref: function ref(node) {
          inputRef(node);
          referenceElementRef(node);
        },
        className: "select-input " + (size ? "form-control-" + size : ""),
        readOnly: readonly,
        onBlur: onBlur
      })),
      selectedValue.length > 0 ? React.createElement(ShIcon, {
        icon: ShCloseSolid,
        className: "action-button",
        onClick: onClickClear
      }) : React.createElement(ShIcon, {
        icon: ShSearch,
        className: "action-button",
        onClick: onClickSearch
      })
    )
  );
};
var FormSearch = function FormSearch(_ref2) {
  var size = _ref2.size,
      groupBy = _ref2.groupBy,
      _ref2$labelKey = _ref2.labelKey,
      labelKey = _ref2$labelKey === undefined ? "label" : _ref2$labelKey,
      _ref2$selected = _ref2.selected,
      selected = _ref2$selected === undefined ? [] : _ref2$selected,
      options = _ref2.options,
      onChange = _ref2.onChange,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === undefined ? false : _ref2$multiple,
      onClickClear = _ref2.onClickClear,
      noBorder = _ref2.noBorder,
      readonly = _ref2.readonly,
      onBlur = _ref2.onBlur,
      onInputChange = _ref2.onInputChange,
      onPressEnter = _ref2.onPressEnter,
      rest = _objectWithoutProperties(_ref2, ["size", "groupBy", "labelKey", "selected", "options", "onChange", "multiple", "onClickClear", "noBorder", "readonly", "onBlur", "onInputChange", "onPressEnter"]);

  var _useState = useState(false),
      isDirty = _useState[0],
      setIsDirty = _useState[1];

  var ref = useRef();

  var defaultFilter = useCallback(function (option, props) {
    if (isDirty) {
      if (!props.text) {
        return true;
      }

      return option[props.labelKey] && option[props.labelKey].toLowerCase().indexOf(props.text.toLowerCase()) !== -1;
    }

    return true;
  }, [isDirty]);

  var onMenuToggle = useCallback(function (isOpen) {
    if (!isOpen) {
      setIsDirty(false);
    }
  }, [setIsDirty]);

  var onInputChangeFn = useCallback(function (e) {
    if (!isDirty) {
      setIsDirty(true);
    }

    onChange(e);
  }, [setIsDirty, isDirty, onChange]);

  var onKeyDownFn = useCallback(function (e) {
    onChange(e.target.value);
    if (e.keyCode === 13 && onPressEnter) {
      e.preventDefault();
      onPressEnter(e.target.value, e);
    }
  }, [onChange, onPressEnter]);
  var onClickMenuItem = useCallback(function (e) {
    onChange(e.currentTarget.dataset.optionkey);
  }, [onChange]);

  var onClickClearFn = useCallback(function () {
    onChange("");
    if (onClickClear) {
      onClickClear();
    }
  }, [onChange, onClickClear]);

  var selectedValue = useMemo(function () {
    var _ref3;

    return selected ? [(_ref3 = {}, _ref3[labelKey] = selected, _ref3.value = selected, _ref3)] : [];
  }, [selected, labelKey]);

  return React.createElement(Typeahead, _extends({
    className: "select-typeahead select-search " + (noBorder ? "no-border" : ""),
    labelKey: labelKey,
    onInputChange: onInputChangeFn,
    onMenuToggle: onMenuToggle,
    filterBy: defaultFilter //Show menu open when click regardless of value already selected or not
    , options: options
    // onChange={(value)=>console.debug("VALUE:",value)}
    , onKeyDown: onKeyDownFn
    //   defaultSelected={selected}
    , multiple: false,
    clearButton: false,
    readonly: readonly,
    selected: selectedValue
  }, rest, {
    ref: ref,
    renderMenu: function renderMenu(results, menuProps, state) {
      var index = 0;
      var transformedItemObject = void 0;
      if (groupBy) {
        transformedItemObject = results.reduce(function (r, item) {
          var key = item[groupBy] || "~";
          if (r[key]) {
            r[key].push(item);
          } else {
            r[key] = [item];
          }
          return r;
        }, {});
      } else {
        transformedItemObject = { "~": results };
      }

      var items = Object.keys(transformedItemObject).sort().map(function (item) {
        return React.createElement(
          Fragment,
          { key: item },
          item !== "~" ? React.createElement(
            Menu.Header,
            null,
            item !== "~" ? item : " "
          ) : index !== 0 ? React.createElement(Menu.Divider, null) : null,
          transformedItemObject[item].map(function (i, keyIndex) {
            var isSelected = selectedValue.find(function (item) {
              return item[labelKey] === i[labelKey];
            });
            var item = React.createElement(
              MenuItem,
              {
                key: index,
                option: i,
                position: index,
                className: "" + (isSelected ? "selected" : ""),
                onClick: onClickMenuItem,
                "data-optionkey": i[labelKey]
              },
              React.createElement(
                Highlighter,
                { search: state ? state.text : "" },
                (typeof i === "undefined" ? "undefined" : _typeof(i)) === "object" ? i[labelKey] : i
              ),
              React.createElement(
                "span",
                { className: "menu-item-icon" },
                "\u2713"
              )
            );

            index += 1;
            return item;
          })
        );
      });

      return readonly || options.length === 0 ? null : React.createElement(
        Menu,
        menuProps,
        items
      );
    },
    renderInput: function renderInput(props) {
      return React.createElement(SelectSingleInput, _extends({}, props, {
        selectedValue: selectedValue,
        size: size,
        onClickClear: onClickClearFn,
        readonly: readonly,
        onBlur: onBlur
      }));
    }
  }));
};

FormSearch.defaultProps = {
  noBorder: false,
  onBlur: function onBlur() {},
  labelKey: "label",
  options: []
};

FormSearch.propTypes = process.env.NODE_ENV !== "production" ? {
  /**id is required */
  id: PropTypes.string.isRequired,

  /**placeholder text */
  placeholder: PropTypes.string,

  /**key name of the label for suggestions */
  labelKey: PropTypes.string,

  /**options: list of suggestion */
  options: PropTypes.array,

  /**group items based on attribute */
  groupBy: PropTypes.string,

  /** selected values */
  selected: PropTypes.string.isRequired,

  /**onChange value */
  onChange: PropTypes.func.isRequired,

  /**Border less */
  noBorder: PropTypes.bool,

  /**onBlur input */
  onBlur: PropTypes.func,

  /**on click clear icon */
  onClickClear: PropTypes.func,

  /**
   * on press enter fn
   * onPressEnter(value,event)
   */
  onPressEnter: PropTypes.func
} : {};
export default FormSearch;